<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.tenant' : 'misc.edition.tenant') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="tenantForm" *ngIf="tenantForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="tenantForm.get('name')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="description">{{'attribute.description' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="description" type="text" formControlName="description" class="w-full">
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="exchange">{{'attribute.exchange' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="exchange" type="text" formControlName="exchange" class="w-full">
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="entryDate">{{'attribute.entryDate' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-calendar
            id="entryDate"
            inputId="entryDate"
            formControlName="entryDate"
            [minDate]="fromDate"
            [firstDayOfWeek]="1"
            [showIcon]="true"
            [readonlyInput]="false"
            (onSelect)="changeEntryDate()"
            styleClass="w-full"
            dateFormat="dd/mm/yy"
          ></p-calendar>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="expirationDate">{{'attribute.expirationDate' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-calendar
            id="expirationDate"
            inputId="expirationDate"
            formControlName="expirationDate"
            [minDate]="entryDate"
            [firstDayOfWeek]="1"
            [showIcon]="true"
            [readonlyInput]="false"
            styleClass="w-full"
            dateFormat="dd/mm/yy"
          ></p-calendar>
        </div>
      </div>
    </div>
    <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4" *ngFor="let field of textFields">
        <div class="form-field col-12">
          <label *ngIf="field !== 'email'" for="{{field}}">{{'attribute.' + field | transloco}}</label>
          <label *ngIf="field === 'email'" for="{{field}}">{{'attribute.' + field | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input
            *ngIf="field !== 'phone'"
            pInputText
            class="w-full"
            id="{{field}}"
            formControlName="{{field}}"
          >
          <ngx-intl-tel-input
            *ngIf="field === 'phone'"
            [cssClass]="'w-full'"
            [preferredCountries]="[CountryISO.Spain]"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false"
            [separateDialCode]="true"
            [maxLength]="15"
            [phoneValidation]="true"
            [inputId]="'phone'"
            [numberFormat]="PhoneNumberFormat.International"
            name="phone"
            formControlName="phone"
          ></ngx-intl-tel-input>
        </div>
        <app-validation-errors *ngIf="field === 'email'" [control]="tenantForm.get('email')"></app-validation-errors>
      </div>
    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="'/management/tenants'"
        pButton
        class="p-button-danger"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="tenantForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [disabled]="!tenantForm.valid"
        [loading]="persistingChanges"
        (onClick)="persistTenantData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
